export const styles = {
  buttonContainer: {
    maxWidth: '50%',
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  title: {
    marginLeft: 16,
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: 32,
    fontWeight: '600',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  iconContainer: {
    height: '50%',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}
